import React, { useEffect, useState } from 'react';
import { CartDrawer } from './cart-drawer';

const ByobAddToCartButton = ({ trayData , setTrayData , discountedTotalPrice,  bundleParentId  }) => {
  const [cartDrawer, setCartDrawer] = useState(null);
  const [variantIds, setVariantIds] = useState([]);
  const [trayVariantTitles, setTrayVariantTitles] = useState([]);



  useEffect(() => {
    const drawer = new CartDrawer();
    setCartDrawer(drawer);
  }, []);

  
  useEffect(() => {
    const trayDataVariantIds = trayData.map(item => item.variant_id);
    const trayDataVariantTitles = trayData.map(item => item.title);
    setVariantIds(trayDataVariantIds);
    setTrayVariantTitles(trayDataVariantTitles);

    console.log('Tray Variant Titles', trayDataVariantTitles);
  }, [trayData]);


  const handleAddToCart = async () => {
    // alert('add to cart');
    // generate bundleKey
    const bundleKey =  Math.floor(Math.random() * 1000000).toString();

    console.log(bundleKey);

    const formData = new FormData();

    const totalPrice = trayData.reduce((sum, item) => {
      // Remove "$" and parse the remaining string as a float
      const itemPrice = parseFloat(item.price.replace('$', ''));
      return sum + itemPrice;
    }, 0);





      // Add parent product
    formData.append('items[0][id]', bundleParentId);
    formData.append('items[0][quantity]', '1');
    formData.append('items[0][properties][_is_bundle_parent]', 'true');
    formData.append('items[0][properties][_bundle_key]', bundleKey);
    formData.append('items[0][properties][_bundle_title]', 'Tray-' + bundleKey);
    formData.append('items[0][properties][_bundle_discounted_price]',  discountedTotalPrice.toFixed(2));
    formData.append('items[0][properties][_bundle_total_price]', totalPrice.toFixed(2));
    formData.append('items[0][properties][_bundle_new_price]',  (totalPrice - discountedTotalPrice).toFixed(2));
    formData.append('items[0][properties][_child_variant_ids]', variantIds.join(','));
    formData.append('items[0][properties][child_variant_titles]', trayVariantTitles.join(','));


    // Add tray items
    trayData.forEach((item, index) => {
      formData.append(`items[${index + 1}][id]`, item.variant_id);
      formData.append(`items[${index + 1}][quantity]`, '1');
      formData.append(`items[${index + 1}][properties][_is_bundle_parent]`, 'false');
      formData.append(`items[${index + 1}][properties][_bundle_key]`, bundleKey);
      formData.append(`items[${index + 1}][properties][_bundle_title]`, 'Custom-Bundle-' + bundleKey);
    });

    console.log('Total Bundle Price', totalPrice)


    try {
      if (cartDrawer) {
        await cartDrawer.addToCart(formData);
        await cartDrawer.getCart();
        cartDrawer.openCartDrawer();
        setTrayData([]);
      }
    } catch (error) {
      console.log("Error adding items to cart:", error);
    }
  }

  return (
        <button 
        className={`w-1/2 md:w-full ${trayData.length < 3 ? 'bg-gray-500 text-white opacity-50' : 'bg-[#63929e] text-white' } text-black px-2 py-2 rounded-lg my-`} 
        disabled={trayData.length < 3} data-add-to-cart onClick={handleAddToCart}
        aria-label="Add To Build Your Own Bundle Tray To Cart"
        role="button"
        tabIndex="0"
        >Add To Cart</button>
  )
}

export default ByobAddToCartButton;